import { ROUTE_PAGE_SUBSCRIPTION } from '@components/Router/constants'
import { AngleRight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { Link } from 'react-router-dom'

import { clsJoin } from '@/utils'
import { AnnualPlanCallout } from './components/AnnualPlanCallout'
import css from './styles.module.css'

interface Props {
  storageUsage: number
  // The personal space has no members to count: it is one person by
  // definition, and a counter reading 1 next to a subscription billing several
  // seats reads as unused seats. null hides the row there.
  members: number | null
  activeMembers: number
  projects: number
}

export const SubscriptionInfo: React.FC<Props> = ({
  storageUsage: usage,
  members,
  activeMembers,
  projects,
}) => {
  const progressClassnames = clsJoin(
    css.progress,
    usage < 80 && css.topaz,
    usage >= 80 && usage < 90 && css.orange,
    usage >= 90 && css.coral
  )

  return (
    <div className={css.subscription_container}>
      <AnnualPlanCallout members={activeMembers} />

      <div className={css.subscription_wrapper}>
        <div className={css.subscription_item}>
          <div className={css.subscription_title}>Projects</div>
          <div className={css.subscription_description}>{projects}</div>
        </div>

        <div className={css.divider} />

        {members !== null && (
          <>
            <div className={css.subscription_item}>
              <div className={css.subscription_title}>Members</div>
              <div className={css.subscription_description}>{members}</div>
            </div>

            <div className={css.divider} />
          </>
        )}

        <div
          className={clsJoin(css.subscription_item, css.subscription_storage)}
        >
          <div className={css.subscription_title}>Storage</div>
          <div className={css.subscription_description}>{usage}%</div>
        </div>

        <div className={css.progress_wrap}>
          <div className={css.divider} />
          <div className={progressClassnames} style={{ width: `${usage}%` }} />
        </div>

        <Link to={ROUTE_PAGE_SUBSCRIPTION} className={css.subscription_link}>
          <div className={css.subscription_title}>Plan and billing</div>
          <div className={css.subscription_icon}>
            <AngleRight />
          </div>
        </Link>
      </div>
    </div>
  )
}
